import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'accounts',
  inputShow: gql`
    query accounts($input: AccountQueryInput) {
      accounts(input: $input) {
        id
        first_name
        last_name
        phone_number
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    label: 'Accounts',
    group: 'root',
    order: 0,
  },
};
